/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/video-editor-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/video-editor-api-client";
import type { ProjectsCreateMutationRequest, ProjectsCreateMutationResponse } from "../models/ProjectsCreate";

export function getProjectsCreateUrl() {
  const res = { method: 'POST', url: `/projects` as const }  
  return res
}

/**
 * @summary Create a project from a source
 * {@link /projects}
 */
export async function projectsCreate(data: ProjectsCreateMutationRequest, config: Partial<RequestConfig<ProjectsCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<ProjectsCreateMutationResponse, ResponseErrorConfig<Error>, ProjectsCreateMutationRequest>({ method : "POST", url : getProjectsCreateUrl().url.toString(), data : requestData, ... requestConfig })  
  return res.data
}